import { Box, Icon, Text } from '@fairfashion/design-system'

import { getReadableNumber } from '../../../utilities/strings/getReadableNumber'
import { DashboardCardMenu } from '../DashboardCardMenu/dashboard-card-menu.comp'

import * as Styles from './dashboard-card.styles'
import { DashboardCardProps } from './dashboard-card.types'

export const DashboardCard = ({
  title,
  icon,
  value,
  details,
  url,
  color,
  bigTitle,
  ...rest
}: DashboardCardProps) => {
  return (
    <Styles.Card
      padding={4}
      direction="column"
      width="100%"
      justifyContent="center"
      {...rest}
    >
      <DashboardCardMenu title={title} details={details} url={url} />

      <Box gap={2} alignItems="center">
        <Styles.IconContainer>
          <Icon name={icon} color={color} size={24} />
        </Styles.IconContainer>
      </Box>

      <Box direction="column" marginTop={2}>
        <Box width="100%" height={bigTitle ? '50px' : 'auto'}>
          <Text fontWeight={500}>{title}</Text>
        </Box>
        <Styles.CardValue>{getReadableNumber(value)}</Styles.CardValue>
      </Box>
    </Styles.Card>
  )
}
